import * as RxCheckbox from "@radix-ui/react-checkbox";
import cx from "clsx";
import Flex from "kreate-common/modules/kreate-ui/components/Flex";
import React from "react";
import { MdCheck } from "react-icons/md";

import styles from "./index.module.scss";

type Props = {
  className?: string;
  style?: React.CSSProperties;
  value: boolean;
  onChange?: (value: boolean) => void;
  label?: React.ReactNode;
  title?: string;
  disabled?: boolean;
};

export default function Checkbox({
  className,
  style,
  value,
  onChange,
  label,
  title,
  disabled,
}: Props) {
  return (
    <div className={cx(styles.container, className)} style={style}>
      <Flex.Row gap="12px" asChild>
        <label style={{ cursor: "pointer" }} title={title}>
          <RxCheckbox.Root
            className={styles.checkboxContainer}
            checked={value}
            onCheckedChange={(value) =>
              typeof value === "boolean" && onChange?.(value)
            }
            disabled={disabled}
          >
            <RxCheckbox.Indicator className={styles.checkboxIndicator}>
              <MdCheck size="24px" />
            </RxCheckbox.Indicator>
          </RxCheckbox.Root>
          <div className={styles.label}>{label}</div>
        </label>
      </Flex.Row>
    </div>
  );
}
